import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQsFour() {
  const faqItems = [
    {
      id: "item-1",
      question: "What is the difference between the Free and Pro versions?",
      answer:
        "The free version is a great way to start. It gives you full, unlimited access to Module 1 (Mathematics) and Module 2 (Physics) in both Exam and Study modes. The Pro subscription unlocks the entire platform, giving you access to all 17 modules, the advanced performance dashboard, detailed post-exam analytics to pinpoint your weak areas, and unlimited exam attempts across the entire syllabus. The free version lets you see how it works; Pro is the complete toolkit to get you certified.",
    },
    {
      id: "item-2",
      question: "How accurate are the questions?",
      answer:
        "Our questions are carefully created by aviation professionals to be a realistic representation of the topics and formats you will encounter in the official EASA exams. They are based on the official Part-66 syllabus. However, may similar but they are not the actual questions from the live exams. This app is a powerful study aid designed to prepare you for the real thing, not an exact copy of the test.",
    },
    {
      id: "item-3",
      question: "What is the source of the questions?",
      answer:
        "Our extensive question bank is developed in-house and curated from materials provided by trusted EASA Part-66 training organizations. We focus on covering the entire syllabus to ensure you have a comprehensive and effective study experience.",
    },
    {
      id: "item-4",
      question: "Can I use the app offline?",
      answer:
        "To start a new exam or study session, you need an internet connection to download the set of questions from our server. However, once a session has started, you can complete it entirely offline. If your connection drops mid-exam, your progress will not be affected. This ensures you always practice with up-to-date content while giving you the flexibility to study anywhere.",
    },
    {
      id: "item-5",
      question: "How often is the app updated?",
      answer:
        "We regularly review and expand our question bank to ensure it remains current with the EASA syllabus. We also continuously update the app with new features and improvements based on user feedback to provide the best possible learning experience.",
    },
    {
      id: "item-6",
      question: "Do you offer discounts for schools or bulk purchases?",
      answer:
        "Yes, we provide special pricing for Part-147 approved schools and other aviation training organizations. Our platform can be an excellent internal tool for student assessment. Please contact us at support@tabbythecat.com for more information on bulk licensing.",
    },
  ];
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="mx-auto max-w-xl text-center">
          <h2 className="text-balance text-3xl font-bold md:text-4xl lg:text-5xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground mt-4 text-balance">
            Discover quick answers to common questions about the{" "}
            <b>Part-66 Exam Pro</b> iOS app.
          </p>
        </div>

        <div className="mx-auto mt-12 max-w-xl">
          <Accordion
            type="single"
            collapsible
            className="bg-muted dark:bg-muted/50 w-full rounded-2xl p-1"
          >
            {faqItems.map((item) => (
              <div className="group" key={item.id}>
                <AccordionItem
                  value={item.id}
                  className="data-[state=open]:bg-card dark:data-[state=open]:bg-muted peer rounded-xl border-none px-7 py-1 data-[state=open]:border-none data-[state=open]:shadow-sm"
                >
                  <AccordionTrigger className="cursor-pointer text-base hover:no-underline">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent>
                    <p className="text-base">{item.answer}</p>
                  </AccordionContent>
                </AccordionItem>
                <hr className="mx-7 border-dashed group-last:hidden peer-data-[state=open]:opacity-0" />
              </div>
            ))}
          </Accordion>

          <p className="text-muted-foreground mt-6 px-8 text-center">
            Can't find what you're looking for? Please reach out to our{" "}
            <a
              href="mailto:support@tabbythecat.com"
              className="text-primary font-medium hover:underline"
            >
              customer support team
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
